const orientationToString = orientation =>
  orientation?.name
    ?? `${orientation.viewPlaneNormal.join('|')}~${orientation.viewUp.join('|')}`;

export default orientationToString;